import React from 'react';
import classNames from 'classnames';

type Props = {
  disabled?: boolean,
  outline?: boolean,
  outlineDark?: boolean,
  content: string,
  dataId?: string,
};

function ButtonSubmit(props: Props) {
  const { disabled, outline, outlineDark, content, dataId } = props;
  const btnClass = classNames({
    disabled,
    'bttn--primary': !outline,
    'bttn-outline bttn-outline--primary': outline,
    'bttn-outline--dark': outlineDark,
  });
  return (
    <button
      type="submit"
      className={btnClass}
      data-automation-id={dataId && dataId}
    >
      <span className="bttn__content">{content}</span>
    </button>
  );
}

ButtonSubmit.defaultProps = {
  disabled: false,
  outline: false,
  outlineDark: false,
  dataId: null,
};

export default ButtonSubmit;
